




















import Vue from "vue";
import { modalService } from "@/services/modal-service.ts";

export default Vue.extend({
  name: "Memeber",
  props: ["member", "buttonColor"],
  methods: {
    showBio() {
      modalService.openModal(this.member);
    }
  }
});
